<script>
import vue2Dropzone from "vue2-dropzone";
import { Download } from "@/mixins/download";
import { mapGetters } from "vuex";
/**
 * File Uploads component
 */
export default {
  components: { vueDropzone: vue2Dropzone },
  mixins: [Download],
  props: [
    "dialog",
    "closeModal",
    "modalTitle",
    "modalNote",
    "uploadSuccess",
    "downloadTemplate",
    "errors",
    "downloadButtonText",
    "footerText",
  ],

  data() {
    return {
      title: "Import Orders",
      modal: true,
      media: [],
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 500,
        maxFilesize: 15,
        headers: { "My-Awesome-Header": "header value" },
        acceptedFiles:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        maxFiles: 1,
        autoProcessQueue: false,
        addRemoveLinks: true,
        dictRemoveFile: "Remove",
        previewTemplate: this.template(),
        uploadMultiple: false,
        maxfilesexceeded(file) {
          this.removeFile(file);
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      services: ["auth/services"],
    }),
  },
  methods: {
    template: function () {
      return `<div class="dz-preview dz-file-preview">
                <div class="dz-image">
                    <div data-dz-thumbnail-bg></div>
                </div>
                <div class="dz-details">
                    <div class="dz-size"><span data-dz-size></span></div>
                    <div class="dz-filename"><span data-dz-name></span></div>
                </div>
                <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                <div class="dz-error-message"><span data-dz-errormessage></span></div>
                <div class="dz-success-mark"><i class="fa fa-check"></i></div>
                <div class="dz-error-mark"><i class="fa fa-plus"></i></div>
            </div>
        `;
    },
    uploadOrders() {
      this.media = this.$refs.myVueDropzone.getAcceptedFiles();

      if (this.media.length === 0) return;
      this.$refs.myVueDropzone.processQueue();
      this.uploadSuccess(this.media[0]);
      //   this.$refs.myVueDropzone.processQueue();
    },
    modalTemplate() {
      this.downloadTemplate();
    },
    handelModalClose() {
      this.closeModal();
      this.$refs.myVueDropzone?.removeAllFiles();
      setTimeout(() => {
        this.errors = [];
      }, 1000);
    },
  },
  destroyed() {
    this.closeModal();
    this.$refs.myVueDropzone?.removeAllFiles();
    this.errors = [];
  },
};
</script>

<template>
  <v-dialog
    class="relative"
    v-model="dialog"
    max-width="650"
    @input="handelModalClose"
  >
    <div>
      <button class="close-btn" @click="handelModalClose">
        <v-icon size="22" class="mb-1 ml-1">$vuetify.icons.closeIcon</v-icon>
      </button>
    </div>
    <div class="card mb-0 px-3 py-5">
      <div class="card-body">
        <div
          v-if="errors.length > 0"
          class="d-flex flex-column align-items-center mb-2"
        >
          <v-icon color="primary" size="30">$vuetify.icons.error</v-icon>
          <div class="flex-grow-1 align-self-center mt-3">
            <h4 class="card-subtitle text-center">
              Unable to import {{ modalTitle }}
            </h4>
          </div>
        </div>
        <div v-else class="d-flex flex-column align-items-center mb-2">
          <div class="flex-grow-1 align-self-center">
            <h4 class="card-subtitle text-center text-info">
              {{ modalTitle }}
            </h4>
          </div>
        </div>
        <p v-if="errors.length > 0" class="card-title text-center mb-3">
          To import these {{ modalTitle }}, please make the following changes:
        </p>
        <div v-else>
          <p class="card-title-desc text-center font-size-15">
            {{
              $t(
                "Download the template, fill in the required data and upload the sheet once you finish"
              )
            }}
          </p>
          <slot />
        </div>

        <!-- file upload -->
        <div v-if="errors.length > 0">
          <div
            class="text-danger text-center"
            v-for="(error, index) in errors"
            :key="index"
          >
            {{ error }}
          </div>
        </div>

        <vue-dropzone
          class="vue-dropzone dropzone m-10"
          id="dropzone"
          ref="myVueDropzone"
          :include-styling="false"
          :use-custom-slot="true"
          :options="dropzoneOptions"
        >
          <div class="dropzone-custom-content">
            <div>
              <v-icon size="45" class="p-1"> $vuetify.icons.import </v-icon>
            </div>
            <p>
              {{ $t("Click to upload your file or drag and drop it here!") }}
            </p>
          </div>
        </vue-dropzone>

        <p class="card-title-desc text-center mt-3">
          <span class="text-info">{{ $t("#Notes:") }} </span> - {{ modalNote }}
        </p>

        <div class="text-center mt-4">
          <b-button
            type="button"
            variant="primary"
            class="btn-block"
            @click="uploadOrders"
            >{{ $t("Import") }}</b-button
          >
        </div>
      </div>
    </div>
  </v-dialog>
</template>
<style>
.vue-dropzone {
  border: 1px dashed #50a5f1 !important;
  border-radius: 8px !important;
  font-family: "Arial", sans-serif;
  letter-spacing: 0.2px;
  color: #777;
  transition: 0.2s linear;
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: 150px !important;
  min-height: 180px !important;
}
.v-dialog {
  position: relative !important;
}
.close-btn {
  display: inline-block;
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 9;
  /* text-align: right;
  border: 2px solid #9aa5b0;
  color: #9aa5b0;
  padding: 2px;
  width: 25px;
  height: 25px;
  line-height: 18px;
  font-size: 18px;
  border-radius: 5px; */
}
.vue-dropzone:hover {
  background-color: #f6f6f6;
}
.vue-dropzone > i {
  color: #ccc;
}
.vue-dropzone > .dz-preview {
  width: 75%;
  display: flex;
  justify-content: center;
}
.dropzone .dz-preview .dz-progress {
  opacity: 1;
  z-index: 1000;
  pointer-events: none;
  position: absolute;
  height: 16px;
  left: unset;
  top: 50%;
  margin-top: -8px;
  width: 60%;
  margin-left: 0;
  background: rgba(255, 255, 255, 0.9);
  -webkit-transform: scale(1);
  border-radius: 8px;
  overflow: hidden;
}
.vue-dropzone > .dz-preview .dz-image {
  border-radius: 0;
  width: 100% !important;
  height: 100%;
}
.vue-dropzone > .dz-preview .dz-image img:not([src]) {
  width: 200px;
  height: 200px;
}
.vue-dropzone > .dz-preview .dz-image:hover img {
  transform: none;
  -webkit-filter: none;
}
.vue-dropzone > .dz-preview .dz-details {
  bottom: 0;
  top: 0;
  color: white;
  background-color: rgba(33, 150, 243, 0.8);
  transition: opacity 0.2s linear;
  text-align: left;
  background-color: var(--v-primary-base) !important;
}
.vue-dropzone > .dz-preview .dz-details .dz-filename {
  overflow: hidden;
}
.vue-dropzone > .dz-preview .dz-details .dz-filename span,
.vue-dropzone > .dz-preview .dz-details .dz-size span {
  color: white;
  background-color: transparent;
}
.vue-dropzone > .dz-preview .dz-details .dz-filename:not(:hover) span {
  border: none;
  margin-top: 15px;
  display: inline-block;
}
.vue-dropzone > .dz-preview .dz-details .dz-filename:hover span {
  background-color: transparent;
  border: none;
}
.vue-dropzone > .dz-preview .dz-progress .dz-upload {
  background: var(--v-info-base);
}
.vue-dropzone > .dz-preview .dz-remove {
  position: absolute;
  z-index: 3000;
  color: white;
  margin-left: 15px;
  padding: 10px;
  top: inherit;
  bottom: 15px;
  border: 2px white solid;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 0.8rem;
  font-weight: 800;
  letter-spacing: 1.1px;
  background-color: var(--v-secondary-base);
  border-radius: 5px;
  opacity: 0;
}
.vue-dropzone > .dz-preview:hover .dz-remove {
  opacity: 1;
}

.vue-dropzone > .dz-preview .dz-success-mark,
.vue-dropzone > .dz-preview .dz-error-mark {
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  top: 35%;
  left: 42.5%;

  font-size: 200%;
  border-radius: 50%;
}
.vue-dropzone > .dz-preview .dz-success-mark {
  color: #fff !important;
  background-color: var(--v-success-base) !important;
}
.vue-dropzone > .dz-preview .dz-error-mark {
  color: white !important;
  background-color: var(--v-secondary-base) !important;
}
.vue-dropzone > .dz-preview .dz-error-mark i {
  -webkit-transform: rotate(45deg) !important;
  transform: rotate(45deg) !important;
}
.dropzone .dz-preview.dz-error .dz-error-mark {
  opacity: 1;
  -webkit-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);
  animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);
}
.vue-dropzone > .dz-preview .dz-success-mark svg,
.vue-dropzone > .dz-preview .dz-error-mark svg {
  margin-left: auto;
  margin-right: auto;
}
.vue-dropzone > .dz-preview .dz-error-message {
  margin-left: auto;
  margin-right: auto;
  left: 0;
  width: 100%;
  text-align: center;
}
.vue-dropzone > .dz-preview .dz-error-message:after {
  display: block;
}
.dropzone-custom-content p {
  font-weight: 400;
  font-size: 16px;
  margin-top: 20px;
  color: #57697b;
}

.dropzone-custom-content > div {
  position: relative;
}
.dropzone-custom-content > div::after,
.dropzone-custom-content > div::before {
  content: "";
  position: absolute;
  bottom: 20px;
  background: #48beea;
  height: 1px;
  width: 160px;
}
.dropzone-custom-content > div::after {
  right: -15px;
}
.dropzone-custom-content > div::before {
  left: -20px;
}
.dropzone .dz-message {
  margin: 1.5em 0 !important;
}
</style>
